import { enumOptionsToObject } from '../../internal'
import { z } from 'my-zod'

export const competitiveBrandUtilizedOptions = [
  'Polaris',
  'BRP',
  'Yamaha',
  'Kawasaki',
  'HarleyDavidson',
  'TOMCAR',
  'Jeep',
  'Honda',
  'ArcticCat',
  'ROXOR',
  'CFMoto',
  'SeaDoo',
  'YamahaPWC',
  'Starcraft',
  'Suntracker',
  'Chaparral',
  'Unknown'
] as const

export const competitiveBrandsUtilized = enumOptionsToObject(competitiveBrandUtilizedOptions)

export type CompetitiveBrandUtilized = (typeof competitiveBrandUtilizedOptions)[number]

export const competitiveBrandUtilizedLabels: Record<CompetitiveBrandUtilized, string> = {
  Polaris: 'Polaris',
  BRP: 'BRP',
  Yamaha: 'Yamaha',
  Kawasaki: 'Kawasaki',
  HarleyDavidson: 'Harley Davidson',
  TOMCAR: 'TOMCAR',
  Jeep: 'Jeep',
  Honda: 'Honda',
  ArcticCat: 'Arctic Cat',
  ROXOR: 'ROXOR',
  CFMoto: 'CF Moto',
  SeaDoo: 'Sea Doo',
  YamahaPWC: 'Yamaha PWC',
  Starcraft: 'Starcraft',
  Suntracker: 'Suntracker',
  Chaparral: 'Chaparral',
  Unknown: 'Unknown'
}

export const CompetitiveBrandsUtilizedEnum = z
  .enum(competitiveBrandUtilizedOptions)
  .setEnumLabels(competitiveBrandUtilizedLabels)
